import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from 'app/core/internationalization/translation.service';


export type SSO_PROVIDER = 'Google';

const SSO_PROVIDER_LOOKUP: Record<SSO_PROVIDER, string> = {
  'Google': "sso-providers/google.svg",
}

@Component({
    selector: 'kh-sso-provider-button',
    styleUrls: ['./sso-provider-button.component.less'],
    templateUrl: './sso-provider-button.component.html',
    standalone: false
})
export class SSOProviderButtonComponent {
  @Input() public provider: SSO_PROVIDER = 'Google';
  @Output() public click = new EventEmitter<SSO_PROVIDER>();
  public buttonText: string;
  public logo: string;

  public constructor(private readonly _translationService: TranslationService) {
    this.buttonText = this._translationService.instant("SSO_PROVIDER_BUTTON.LOG_IN_WITH_PROVIDER", {Provider: this.provider});
    this.logo = "sso-providers/google.svg";
  }

  public onClick(): void {
    this.click.next(this.provider);
  }
}
